"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const TierStatusEnum_1 = require("../enums/TierStatusEnum");
const Time = __importStar(require("@sellout/utils/.dist/time"));
exports.default = {
    isPastTier(ticketType, tier) {
        const now = Time.now();
        const endsAt = tier === null || tier === void 0 ? void 0 : tier.endsAt;
        if (tier.remainingQty === 0)
            return true;
        if (!endsAt || now <= endsAt)
            return false;
        else
            return true;
    },
    isInProgress(ticketType, tier) {
        var _a;
        //const now = Time.now();
        // const startsAt = tier?.startsAt;
        //const endsAt = tier?.endsAt;
        const remainingQty = tier.remainingQty;
        const tierIndex = ticketType === null || ticketType === void 0 ? void 0 : ticketType.tiers.map((tier) => tier._id).indexOf(tier._id);
        let previousTier = null;
        if (tierIndex && tierIndex > -1) {
            const previousTierIndex = tierIndex - 1;
            previousTier = (_a = ticketType === null || ticketType === void 0 ? void 0 : ticketType.tiers[previousTierIndex]) !== null && _a !== void 0 ? _a : null;
        }
        const previousTierIsPast = previousTier
            ? this.isPastTier(ticketType, previousTier)
            : true;
        const hasBegun = previousTierIsPast;
        const hasEnded = remainingQty <= 0;
        return hasBegun && !hasEnded;
    },
    isNotStarted(ticketType, tier) {
        var _a;
        const now = Time.now();
        // const startsAt = tier?.startsAt;
        const endsAt = tier === null || tier === void 0 ? void 0 : tier.endsAt;
        const remainingQty = tier.remainingQty;
        const tierIndex = ticketType === null || ticketType === void 0 ? void 0 : ticketType.tiers.map((tier) => tier._id).indexOf(tier._id);
        let previousTier = null;
        if (tierIndex && tierIndex > -1) {
            const previousTierIndex = tierIndex - 1;
            previousTier = (_a = ticketType === null || ticketType === void 0 ? void 0 : ticketType.tiers[previousTierIndex]) !== null && _a !== void 0 ? _a : null;
        }
        const previousTierIsPast = previousTier
            ? this.isPastTier(ticketType, previousTier)
            : true;
        const hasBegun = previousTierIsPast;
        const hasEnded = remainingQty <= 0 || (endsAt && endsAt < now);
        return !hasBegun && !hasEnded;
    },
    currentTier(ticketType) {
        const tiers = ticketType.tiers;
        const tier = tiers.find(tier => this.isInProgress(ticketType, tier));
        return tier || null;
    },
    tierStatus(ticketType, tier) {
        if (this.isInProgress(ticketType, tier))
            return TierStatusEnum_1.TierStatusEnum.InProgress;
        if (this.isPastTier(ticketType, tier))
            return TierStatusEnum_1.TierStatusEnum.Past;
        if (this.isNotStarted(ticketType, tier))
            return TierStatusEnum_1.TierStatusEnum.NotStarted;
        return TierStatusEnum_1.TierStatusEnum.NotStarted;
    }
};
//# sourceMappingURL=TierUtil.js.map